/* ============================================================
   Luz de cuello siahs · PDP · interactividad del buy box
   - Galería con miniaturas
   - Selector de packs = variantes reales
   - Sincroniza precio, precio comparado y ahorro
   - Sincroniza y enlaza la barra sticky inferior con el carrito
   ============================================================ */
(function () {
  function init(root) {
    if (!root || root.__luzInit) return;
    root.__luzInit = true;

    // ---- datos de variantes (precios ya formateados por Liquid) ----
    var data = {};
    var dataEl = root.querySelector('[data-luz-variants]');
    if (dataEl) {
      try { data = JSON.parse(dataEl.textContent); } catch (e) { data = { variants: [] }; }
    }
    var variants = (data && data.variants) || [];
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });

    // ---- galería ----
    var mainImg = root.querySelector('[data-luz-main]');
    var thumbs = root.querySelectorAll('[data-luz-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        var alt = btn.getAttribute('data-alt') || '';
        if (mainImg && full) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = full;
          if (alt) mainImg.alt = alt;
        }
        thumbs.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-current', 'false'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-current', 'true');
      });
    });

    // ---- zoom (lightbox) de la imagen principal ----
    if (mainImg) {
      mainImg.style.cursor = 'zoom-in';
      mainImg.addEventListener('click', function () {
        var ov = document.createElement('div');
        ov.className = 'luz-zoom-ov';
        var im = document.createElement('img');
        im.src = mainImg.currentSrc || mainImg.src;
        im.alt = mainImg.alt || '';
        ov.appendChild(im);
        ov.addEventListener('click', function () { ov.remove(); });
        document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { ov.remove(); document.removeEventListener('keydown', esc); } });
        document.body.appendChild(ov);
      });
    }

    // ---- selector de packs (variantes) ----
    var form = root.querySelector('form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = root.querySelector('[data-luz-price]');
    var compareEl = root.querySelector('[data-luz-compare]');
    var saveEl = root.querySelector('[data-luz-save]');

    // barra sticky (puede estar fuera de la sección principal)
    var stickyPrice = document.querySelector('[data-luz-sticky-price]');
    var stickyCompare = document.querySelector('[data-luz-sticky-compare]');
    var stickySave = document.querySelector('[data-luz-sticky-save]');

    function apply(variantId) {
      var v = byId[String(variantId)];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price_str;
      if (compareEl) {
        if (v.compare_str) { compareEl.textContent = v.compare_str; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (saveEl) {
        if (v.save) { saveEl.textContent = 'AHORRA ' + v.save; saveEl.hidden = false; }
        else { saveEl.hidden = true; }
      }
      if (stickyPrice) stickyPrice.textContent = v.price_str;
      if (stickyCompare) {
        if (v.compare_str) { stickyCompare.textContent = v.compare_str; stickyCompare.hidden = false; }
        else { stickyCompare.hidden = true; }
      }
      if (stickySave) {
        if (v.save) { stickySave.textContent = '-' + v.save; stickySave.hidden = false; }
        else { stickySave.hidden = true; }
      }
    }

    var packInputs = root.querySelectorAll('[data-luz-pack]');
    packInputs.forEach(function (inp) {
      inp.addEventListener('change', function () { if (inp.checked) apply(inp.value); });
    });
    // aplica el que viene marcado al cargar
    var checked = root.querySelector('[data-luz-pack]:checked');
    if (checked) apply(checked.value);

    // ---- barra sticky: su botón envía el formulario real ----
    var stickyBtn = document.querySelector('[data-luz-sticky-atc]');
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-luz-buybox]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // soporte para el editor de temas (recarga de sección)
  document.addEventListener('shopify:section:load', boot);
})();
